import { create } from 'zustand';
import { syncApi } from './api';

interface SyncState {
  lastTicketsSync: string | null;
  lastContractsSync: string | null;
  isLoading: boolean;
  setSyncDates: (lastTicketsSync: string | null, lastContractsSync: string | null) => void;
  setLoading: (loading: boolean) => void;
  refreshSyncDates: () => Promise<void>;
}

export const useSyncStore = create<SyncState>((set) => ({
  lastTicketsSync: null,
  lastContractsSync: null,
  isLoading: false,
  setSyncDates: (lastTicketsSync, lastContractsSync) =>
    set({
      lastTicketsSync,
      lastContractsSync,
      isLoading: false,
    }),
  setLoading: (isLoading) => set({ isLoading }),
  refreshSyncDates: async () => {
    set({ isLoading: true });
    try {
      const { lastTicketsSync, lastContractsSync } = await syncApi.getLastSyncDates();
      set({ lastTicketsSync, lastContractsSync, isLoading: false });
    } catch (error) {
      console.error('Failed to refresh sync dates:', error);
      set({ isLoading: false });
    }
  },
}));

// Usable outside React components (e.g. right after a sync request finishes)
export const refreshSyncDates = () => useSyncStore.getState().refreshSyncDates();
